import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';
import { ReactNode } from 'react';

export type TAddToProjectItem = {
  productId: number;
  colorId: number;
  name: string;
};

export type TConfirmInfo<P = undefined> = {
  id?: string;
  message?: string | ReactNode;
  title?: string;
  payload?: P;
  onConfirm?: (payload: P) => void | Promise<boolean | void> | boolean;
  onShow?: (payload: P) => Partial<TConfirmInfo> | void;
};

const state = {
  loader: false,
  redirect: null as null | string,
  showTopSearch: false as boolean,
  title: 'Sacco Carpet' as string,
  appVersion: '',
  addToProjectItem: null as null | TAddToProjectItem,
  confirmInfo: null as null | TConfirmInfo,
  uiUpdate: (new Date()).getTime(),
};

type State = typeof state;

export const useUiStore = create<State>()(immer(devtools(() => state, { enabled: true, name: 'uiStore' })));

export function setAppVersion(version: string) {
  return useUiStore.setState((state) => {
    state.appVersion = version;
  });
}

export function showLoader(show = false) {
  return useUiStore.setState((state) => {
    state.loader = show;
  });
}

export function setUiUpdated() {
  return useUiStore.setState((state) => {
    state.uiUpdate = (new Date()).getTime();
  });
}

export function setShowTopSearch(show: boolean) {
  return useUiStore.setState((state) => {
    state.showTopSearch = show;
  });
}

export function setPageTitle(title: string = '') {
  return useUiStore.setState((state) => {
    state.title = title;
    document.title = title ? title + ' - Sacco Carpet' : 'Sacco Carpet';
  });
}

export function setAddToProjectItem(item: null | TAddToProjectItem) {
  return useUiStore.setState((state) => {
    state.addToProjectItem = item;
  });
}

export function setConfirmInfo(info: TConfirmInfo | null) {
  return useUiStore.setState((state) => {
    state.confirmInfo = info;
  });
}